import { render, staticRenderFns } from "./InputAssestment.vue?vue&type=template&id=ad8f670a&scoped=true"
import script from "./InputAssestment.vue?vue&type=script&lang=js"
export * from "./InputAssestment.vue?vue&type=script&lang=js"
import style0 from "./InputAssestment.vue?vue&type=style&index=0&id=ad8f670a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8f670a",
  null
  
)

export default component.exports